require('./components/submenu');
require('./pages/plp_departure');
require('./components/loginTravel');
require('./components/sliderCard');
require('./components/menuResp');
require('./components/slidersHelper');
require('./components/tabsA11y');
require('./newsletter');
require('./components/datepicker');
require('./components/select');
require('./components/productDepartureList');
require('./contactus');
require('./components/scrollToTopButton');
